import { isEmpty } from 'lodash-es';
import { useAppDispatch, useAppSelector } from '../../App/redux/store';
import { modalsActions } from '../../features/modals/modalsSlice';
import { getProcedureEventsState } from '../../features/procedureEvent/reducer';
import { ReactComponent as Bell } from '../../images/bell.svg';

const NotificationBell = () => {
  const { dashboardProcedureEvents } = useAppSelector(getProcedureEventsState);
  const dispatch = useAppDispatch();

  return (
    <div
      className="header-notif"
      onClick={() => dispatch(modalsActions.notificationBell(true))}
    >
      <Bell />
      {!isEmpty(dashboardProcedureEvents) && <div className="header-notif-on"></div>}
    </div>
  );
};

export default NotificationBell;
